const __WEBPACK_NAMESPACE_OBJECT__ = require("@sentry/react");